/**
 * Whether touch is the primary way to point at this device - true on phones and tablets,
 * false on desktop, including touchscreen laptops, where the trackpad is primary.
 *
 * Use this to tell a real handheld apart from a narrow window: viewport helpers like
 * `isMobile()` only measure width, so a resized desktop window satisfies them too. This asks
 * a different question from `'ontouchstart' in window`, which only reports whether touch
 * exists at all.
 */
export function isTouchPrimary(): boolean {
    return window.matchMedia('(pointer: coarse)').matches;
}

/**
 * Same heuristic as smartbanner.js Detector: maxTouchPoints distinguishes
 * real iPads (maxTouchPoints > 0) from Mac desktop Safari (maxTouchPoints = 0).
 */
export function isIosOrIpad(): boolean {
    const { userAgent, maxTouchPoints } = window.navigator;
    return (
        /iPhone|iPad|iPod/i.test(userAgent) ||
        (!('MSStream' in window) && !/X11|Linux|Windows/i.test(userAgent) && maxTouchPoints > 0)
    );
}
